import React, { createContext, useContext, useState } from "react";

const NetworkContext = createContext();

const getInitialNetwork = () => {
  try {
    const savedNetwork = localStorage.getItem("selectedNetwork");

    return savedNetwork
      ? JSON.parse(savedNetwork)
      : { id: 6001, name: "Default" };
  } catch (error) {
    return { id: 6001, name: "Default" };
  }
};

const getInitialLocation = () => {
  try {
    const savedLocation = localStorage.getItem("selectedLocation");

    return savedLocation ? JSON.parse(savedLocation) : null;
  } catch (error) {
    return null;
  }
};

export const NetworkProvider = ({ children }) => {
  const [selectedNetworkIdState, setSelectedNetworkIdState] =
    useState(getInitialNetwork);

  const [selectedLocationState, setSelectedLocationState] =
    useState(getInitialLocation);

  const setSelectedNetworkId = (value) => {
    setSelectedNetworkIdState(value);

    if (value) {
      localStorage.setItem("selectedNetwork", JSON.stringify(value));
    } else {
      localStorage.removeItem("selectedNetwork");
    }
  };

  const setSelectedLocation = (value) => {
    setSelectedLocationState(value);

    if (value) {
      localStorage.setItem("selectedLocation", JSON.stringify(value));
    } else {
      localStorage.removeItem("selectedLocation");
    }
  };

  return (
    <NetworkContext.Provider
      value={{
        selectedNetworkId: selectedNetworkIdState,
        setSelectedNetworkId,
        selectedLocation: selectedLocationState,
        setSelectedLocation,
      }}
    >
      {children}
    </NetworkContext.Provider>
  );
};

export const useNetwork = () => useContext(NetworkContext);